interface DrawPolygonProps {
  ctx: CanvasRenderingContext2D;
  points: { x: number; y: number }[];
  color: string;
  closePath?: boolean;
  showDots?: boolean;
}

export const getCanvasContext = (
  canvasRef: React.RefObject<HTMLCanvasElement>,
) => {
  const canvas = canvasRef.current;
  if (!canvas) return null;

  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  return { canvas, ctx };
};

export const initializeCanvas = (
  canvasRef: React.RefObject<HTMLCanvasElement>,
  imgRef?: React.RefObject<HTMLImageElement>,
) => {
  const canvas = canvasRef.current;
  const img = imgRef.current;

  if (img && canvas) {
    canvas.width = img.clientWidth;
    canvas.height = img.clientHeight;

    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    }
  }
};

export const drawRectangle = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  color: string,
) => {
  ctx.strokeStyle = color;
  ctx.lineWidth = 4;
  ctx.strokeRect(x, y, width, height);
};

export const drawPolygon = ({
  ctx,
  points,
  color,
  closePath,
  showDots,
}: DrawPolygonProps) => {
  if (points.length === 0) return;

  if (points.length >= 2) {
    ctx.strokeStyle = color;
    ctx.lineWidth = 4;
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);

    for (let i = 1; i < points.length; i++) {
      ctx.lineTo(points[i].x, points[i].y);
    }

    if (closePath) {
      ctx.closePath();
      // Fill with semi-transparent blue
      ctx.fillStyle = 'rgba(0, 0, 255, 0.1)';
      ctx.fill();
    }

    ctx.stroke();
  }

  if (showDots) {
    points.forEach((point) => {
      ctx.beginPath();
      // ctx.arc(point.x, point.y, 3, 0, 2 * Math.PI);
      ctx.arc(point.x, point.y, 5, 0, 2 * Math.PI);
      ctx.fillStyle = color;
      ctx.fill();
    });
  }
};
